import React from 'react';
import { Typography } from '@/lib/typography';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { tokens } from '@/lib/tokens';

const mockData = {
  sent: 15,
  replies: 8,
  response_rate: 53.3
};

const chartData = [
  { name: 'Sent', value: 15, color: tokens.status.warning.text }, // Sent is pending/warning
  { name: 'Replies', value: 8, color: tokens.status.accepted.text } // Replies are success
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-brand-100 rounded-lg p-3 shadow-sm">
        <p className="text-brand-900">{payload[0].name}</p>
        <p className="text-slate-500">
          Count: <span className="text-brand-900">{payload[0].value}</span>
        </p>
      </div>
    );
  }
  return null;
};

export function ResponseRateChart() {
  return (
    <div className="bg-white rounded-lg border border-brand-100 p-6 shadow-sm">
      <h3 className={Typography.h3}>
        Campaign Response Rate
      </h3>
      <div className="relative">
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              startAngle={180}
              endAngle={0}
              innerRadius={80}
              outerRadius={120}
              paddingAngle={2}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} strokeWidth={0} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="text-center">
            <p className="text-brand-900 font-heading">
              {mockData.response_rate}%
            </p>
            <p className="text-slate-500">
              Response Rate
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center gap-6 mt-4">
        {chartData.map((entry, index) => (
          <div key={index} className="flex items-center gap-2">
            <div
              className="w-3 h-3 rounded-full"
            /* visual-law-ignore */
            />
            <span className="text-slate-500">
              {entry.name}: <span className="text-brand-900">{entry.value}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
